import { render } from "./InventoryRestock.vue?vue&type=template&id=31fc34e0&scoped=true"
import script from "./InventoryRestock.vue?vue&type=script&lang=js"
export * from "./InventoryRestock.vue?vue&type=script&lang=js"

import "./InventoryRestock.vue?vue&type=style&index=0&id=31fc34e0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fc34e0"]])

export default __exports__